import React, { useEffect, useState } from "react";
import Modal from "react-awesome-modal";
import { Link } from "react-router-dom";
import useDelete from "../../Hooks/useDelete";
import useUpdate from "../../Hooks/useUpdate";
import useValidateRole from "../../Hooks/useValidateRole";
import Table from "./../../Components/Table";
import Api from "../../Hooks/Api";
import Upload from "../../Hooks/Upload";
import "./application.css";
import swal from "sweetalert";
const NewApplication = () => {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [view, setView] = useState(false);
  const [viewDependants, setviewDependants] = useState(false);
  const [viewEmployer, setViewEmployer] = useState(false);
  const [viewPermits, setViewPermits] = useState(false);
  const [viewActivities, setViewActivities] = useState(false);
  const [viewDocuments, setViewDocuments] = useState(false);
  const [viewTeam, setViewTeam] = useState(false);
  const [update, setUpdate] = useState(false);
  const [activeTab, setActiveTab] = useState("Applications");
  const [PageRole] = useState("Applications");
  const [allDocuments, setAllDocuments] = useState([]);
  const [genderOptions, setGenderOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [permitClassOptions, setPermitClassOptions] = useState([]);
  const [rolesptions, setRolesptions] = useState([]);

  const [dependantTypeOptions, setDependantTypeOptions] = useState([]);
  const [RowData, setRowData] = useState([]);
  const [allEmployers, setAllEmployers] = useState([]);
  const [allParties, setAllPermits] = useState([]);
  const [alldependants, setAlldependants] = useState([]);
  const [documentTypes, setdocumentTypes] = useState([]);
  const [inputsDocuments, setInputsDocuments] = useState({});
  const [inputsPermit, setinputsPermit] = useState({});
  const [inputsEmployer, setinputsEmployer] = useState({});
  const [inputsTeam, setInputsTeam] = useState({});
  const url = "api/applicants";

  const [selectedFile, setselectedFile] = useState("");
  const [loaded, setloaded] = useState("");
  const [message, setmessage] = useState("");

  const [applicationTypeOptions, setApplicationType] = useState([
    { name: "New application" },
    { name: "Renewal" },
  ]);
  const [permitTypeOptions, setPermitTypeOptions] = useState([
    { name: "Entry permit class G (Investor)" },
    { name: "Entry permit class D (Employed)" },
    { name: "Entry permit special pass" },
  ]);

  const maxSelectFile = (event) => {
    let files = event.target.files; // create file object
    if (files.length > 1) {
      const msg = "Only One file can be uploaded at a time";
      event.target.value = null;
      setmessage(msg);

      return false;
    }
    return true;
  };
  const onChangeHandler = (event, name) => {
    if (
      !inputsDocuments.applicationId ||
      inputsDocuments.applicationId == "undefined"
    ) {
      alert("Coplete application details before uploading documents");
      return;
    }
    //for multiple files
    var files = event.target.files;
    if (maxSelectFile(event)) {
      setselectedFile(files);
      setloaded(0);
      onClickHandler(event, name, files);
    }
  };
  const onClickHandler = (event, name, selectedFile) => {
    event.preventDefault();
    if (selectedFile) {
      const data = new FormData();
      for (var x = 0; x < selectedFile.length; x++) {
        data.append("file", selectedFile[x]);
      }
      Upload.post("/api/upload/files", data, {
        onUploadProgress: (ProgressEvent) => {
          setloaded((ProgressEvent.loaded / ProgressEvent.total) * 100);
        },
      })
        .then((res) => {
          if (res.status == "200" && res.data.resultCode == "00") {
            setmessage("Uploaded successfully");
            setInputsDocuments((inputs) => ({
              ...inputs,
              [name]: res.data.data,
            }));
          } else {
            setmessage("upload fail");
          }
        })
        .catch((err) => {
          setmessage("upload fail");
        });
    } else {
      setmessage("Select a file to upload");
    }
  };

  const fetchDocuments = async (applicationId) => {
    try {
      Api.get(
        "api/applicationsDocuments/getByApplicationId?applicationId=" +
          applicationId,
      )
        .then(function (response) {
          if (response.status === 200) {
            setInputsDocuments(response.data);
            setInputsDocuments((inputsDocuments) => ({
              ...inputsDocuments,
              ["applicationId"]: applicationId,
            }));
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };

  const fetchGender = async () => {
    try {
      Api.get("api/gender/getAll")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setGenderOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching incidentTypes:", error);
    }
  };

  const fetchCountries = async () => {
    try {
      Api.get("api/countries/getAll")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setCountryOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching incidentTypes:", error);
    }
  };
  const fetchPermitClass = async () => {
    try {
      Api.get("api/permitClasses/getAll")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setPermitClassOptions(data.permitClasses);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching incidentTypes:", error);
    }
  };
  const fetchRoles = async () => {
    try {
      Api.get("api/applicantRoles/getAll")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setRolesptions(data.roles);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching incidentTypes:", error);
    }
  };
  const fetchDependantTypeOptions = async () => {
    try {
      Api.get("api/dependantsTypes/getAll")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setDependantTypeOptions(data.dependantsTypes);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching incidentTypes:", error);
    }
  };
  const fetchDocumentTypes = async () => {
    try {
      Api.get("api/docType/getAll?page=0&size=100")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            data.docType.forEach((k) => {
              let col = {
                value: k.id,
                label: k.name,
              };
              setdocumentTypes((documentTypes) => [...documentTypes, col]);
            });
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching incidentTypes:", error);
    }
  };
  const MoreActions = (props) => {
    return (
      <span>
        <a
          class="btn btn-success btn-sm dropdown-toggle"
          href="#"
          role="button"
          id="dropdownMenuLink"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          More Actions&nbsp;&nbsp;
          <i class="fa fa-caret-down" aria-hidden="true"></i>
        </a>

        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <a
            style={{ cursor: "pointer" }}
            class="dropdown-item "
            onClick={(e) => handleView(props.selecteditem, e)}
          >
            View
          </a>

          <a
            style={{ cursor: "pointer" }}
            class="dropdown-item "
            onClick={(e) => handleEdit(props.selecteditem, e)}
          >
            Edit
          </a>
          {/* <a
            style={{ cursor: "pointer" }}
            class="dropdown-item "
            onClick={(e) => HandleDelete(props.selecteditem, e)}
          >
            Delete
          </a> */}
        </div>
      </span>
    );
  };
  const setApplicationsdata = async (data) => {
    const rows = data?.applications || [];

    rows.forEach((k) => {
      const Rowdata = {
        id: k.id,
        refNo: k.id,
        location: k.location,
        profile:
          "Number of Kenyan Employees: " +
          k.kenyanEmployees +
          " number of Expatriates " +
          k.numberOfExpatriates,
        createdAt: new Date(k.applicant.dob).toLocaleDateString("en-GB"),
        fullName: k.applicant?.fullName,
        applicationType: k.applicationType,
        permitType: k.permitType,
        country: k.applicant?.country?.name,
        telNo: k.applicant?.telNo,
        email: k.applicant?.email,
        passportNumber: k.applicant?.passportNumber,
        status: k.status,
        role: k.role?.name,
        dob: new Date(k.applicant.dob).toLocaleDateString("en-GB"),
        Actions: <MoreActions selecteditem={k} />,
      };
      setRowData((inputs) => [...inputs, Rowdata]);
    });
  };
  const FetchAll = async () => {
    setRowData([]);
    try {
      Api.get("api/applications/getMyApplication?page=0&size=10")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setApplicationsdata(data);
            const totalPages = data.totalPages;
            for (let i = 0; i < totalPages; i++) {
              let nextPage = parseFloat(i) + parseFloat(1);
              Api.get(
                "api/applications/getMyApplication?page=" +
                  nextPage +
                  "&size=10",
              )
                .then(function (response) {
                  if (response.status === 200) {
                    const data = response.data;
                    setApplicationsdata(data);
                  }
                })
                .catch(function (error) {})
                .then(function () {
                  // always executed
                });
            }
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  useEffect(() => {
    FetchAll();
    fetchCountries();
    fetchPermitClass();
    fetchDependantTypeOptions();
    fetchGender();
    fetchDocumentTypes();
    fetchRoles();
  }, []);

  const handleOpenModal = () => {
    const currentUserName = window.sessionStorage.getItem("UserName");
    setInputs({ createdBy: currentUserName });
    setOpen(true);
  };

  const handleInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };
  const handlePermitInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setinputsPermit((inputs) => ({ ...inputs, [name]: value }));
  };
  const handleEmployerInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setinputsEmployer((inputs) => ({ ...inputs, [name]: value }));
  };

  const handleEdit = (k) => {
    setInputs(k.applicant);

    setInputsDocuments((inputsDocuments) => ({
      ...inputsDocuments,
      ["applicationId"]: k.id,
    }));

    if (k.id) {
      setOpen(true);
      setUpdate(true);
      setView(false);
      fetchDocuments(k.id);
    } else {
      alert("Select a record to view");
    }
  };
  const handleView = (k) => {
    setInputs(k.applicant);

    setInputsDocuments((inputsDocuments) => ({
      ...inputsDocuments,
      ["applicationId"]: k.id,
    }));
    setInputs((inputs) => ({ ...inputs, ["roleId"]: k.role.id }));
    setInputs((inputs) => ({ ...inputs, ["role"]: k.role }));
    setInputs((inputs) => ({
      ...inputs,
      ["applicationType"]: k.applicationType,
    }));
    setInputs((inputs) => ({ ...inputs, ["role"]: k.role }));
    setInputs((inputs) => ({
      ...inputs,
      ["permitType"]: k.permitType,
    }));
    setInputs((inputs) => ({
      ...inputs,
      ["roleDesc"]: k.roleDesc,
    }));
    if (k.id) {
      fetchDocuments(k.id);

      setView(true);
      setOpen(true);
    } else {
      alert("Select a record to view");
    }
  };
  const handleCloseModal = () => {
    setInputs({});
    setOpen(false);
    setView(false);
    setUpdate(false);
  };

  const HandleUpdate = (inputs, url) => {
    useUpdate(url, inputs);
    setTimeout(function () {
      FetchAll();
    }, 4000);
  };

  const handleSubmitDocuments = (event) => {
    event.preventDefault();
    if (
      !inputsDocuments.applicationId ||
      inputsDocuments.applicationId == "undefined"
    ) {
      alert("Add or select Applicant first");
      return;
    }
    // if (update) {
    //   HandleUpdate(inputsDocuments, "api/applicationsDocuments");
    // } else {
    HandleSave(inputsDocuments, "api/applicationsDocuments", "dependant");
    // }
  };

  const handleDocumentsInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputsDocuments((documents) => ({ ...documents, [name]: value }));
  };
  const useSave = (url = ``, inputs = {}, menu = ``, config = {}) => {
    let data;
    let headers;
    if (inputs instanceof FormData) {
      data = inputs;
      headers = { ...config.headers }; // Don't set Content-Type header, let the browser set it
    } else {
      data = JSON.stringify(inputs);
      headers = { "Content-Type": "application/json", ...config.headers };
    }
    Api.post(url, data, { headers })
      .then((response) => {
        if (response.data.resultCode === "00") {
          if (menu === "Applications") {
            var result = JSON.parse(response.data.data);

            setInputsDocuments((inputsDocuments) => ({
              ...inputsDocuments,
              ["applicationId"]: result.id,
            }));
          }

          swal("", "saved", "success");
        } else {
          swal("", response.data.description, "error");
        }
      })
      .catch((error) => {
        swal("", "Failed", "error");
      });
  };
  const HandleSave = (inputs, url, menu) => {
    useSave(url, inputs, menu);
    setTimeout(function () {
      FetchAll();
    }, 4000);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (update) {
      HandleUpdate(inputs, url);
    } else {
      HandleSave(inputs, url, "Applications");
    }
    setActiveTab("dependants");
  };
  const CallDeleteHook = (id) => {
    useDelete(url + "/delete?id=" + id);
    setTimeout(function () {
      FetchAll();
    }, 4000);
  };
  const HandleDelete = (k) => {
    if (k.id) {
      CallDeleteHook(k.id);
    } else {
      alert("Select a record to delete");
    }
  };

  const columns = [
    { label: "Ref. No", field: "refNo", sort: "asc" },
    { label: "Role", field: "role", sort: "asc" },
    { label: "Passport Number", field: "passportNumber", sort: "asc" },
    { label: "Name", field: "fullName", sort: "asc" },
    { label: "Application Type", field: "applicationType", sort: "asc" },
    { label: "Permit Type", field: "permitType", sort: "asc" },
    { label: "Country", field: "country", sort: "asc" },
    { label: "Tel No", field: "telNo", sort: "asc" },
    { label: "Status", field: "status", sort: "asc" },
    { label: "Application Date", field: "createdAt", sort: "asc" },
    { label: "Actions", field: "Actions", sort: "asc" },
  ];

  const ActionsBtn = () => (
    <div>
      {/* {useValidateRole(PageRole, "Edit") && (
        <button
          className="btn btn-success p-2"
          type="button"
          onClick={handleEdit}
        >
          Update
        </button>
      )} */}
      &nbsp; &nbsp;
      {/* {useValidateRole(PageRole, "Remove") && (
        <button onClick={HandleDelete} className="btn btn-danger p-2">
          Delete
        </button>
      )} */}
      &nbsp;
      <button
        className="btn btn-warning p-2"
        type="button"
        onClick={handleCloseModal}
      >
        Close
      </button>
    </div>
  );

  return (
    <div id="content" className="content">
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item">
          <Link to="/">Home</Link>
        </li>
        <li className="breadcrumb-item active">My Applications</li>
      </ol>
      <h1 className="page-header mb-3">My Applications</h1>
      <div style={{ backgroundColor: "white" }}>
        <div className="row">
          <div className="col-sm-12 d-flex flex-row float-right">
            &nbsp; &nbsp; &nbsp;
            {useValidateRole(PageRole, "AddNew") && (
              <button
                onClick={handleOpenModal}
                className="btn btn-success p-2"
                style={{ marginRight: 5, marginTop: 5 }}
              >
                &nbsp; New Applications&nbsp;
              </button>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <Table Rows={RowData} columns={columns} />
          </div>
        </div>
      </div>

      <Modal visible={open} width="95%" height="95%" effect="fadeInUp">
        <div style={{ overflowY: "auto", height: "100%" }}>
          <a
            className="close"
            onClick={(e) => {
              e.preventDefault();
              handleCloseModal();
            }}
          >
            &times;
          </a>
          <div className="container-fluid">
            <div className="col-sm-12">
              <div className="ibox-content">
                <br />

                <div>
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${activeTab === "Applications" ? "active" : ""}`}
                        id="Applications-tab"
                        onClick={() => setActiveTab("Applications")}
                        role="tab"
                        aria-selected={activeTab === "Applications"}
                      >
                        Applications
                      </a>
                    </li>
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${activeTab === "dependants" ? "active" : ""}`}
                        id="dependants-tab"
                        onClick={() => setActiveTab("dependants")}
                        role="tab"
                        aria-selected={activeTab === "dependants"}
                      >
                        Upload the following mandatory Documents
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    <div
                      className={`tab-pane fade ${activeTab === "Applications" ? "show active" : ""}`}
                      id="Applications-tab-pane"
                      role="tabpanel"
                      aria-labelledby="Applications-tab"
                    >
                      {view ? (
                        <div>
                          <h3>Applications</h3>
                          <table className="table table-sm">
                            <tbody>
                              <tr>
                                <td className="font-weight-bold">
                                  Establishment:
                                </td>
                                <td>{inputs.user?.name}</td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">Role:</td>
                                <td>{inputs.role?.name}</td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">Name:</td>
                                <td>{inputs.fullName}</td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">
                                  Application Type:
                                </td>
                                <td>{inputs.applicationType}</td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">
                                  permit Type:
                                </td>
                                <td>{inputs.permitType}</td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">
                                  Passport Number:
                                </td>
                                <td>{inputs.passportNumber}</td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">Tel No:</td>
                                <td>{inputs.telNo}</td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">Email:</td>
                                <td>{inputs.email}</td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">Gender:</td>
                                <td>{inputs.applicant?.gender?.name}</td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">Country:</td>
                                <td>{inputs.country.name}</td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">
                                  Places Of Birth:
                                </td>
                                <td>{inputs.placesOfBirth}</td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">
                                  Physical Address:
                                </td>
                                <td>{inputs.physicalAddress}</td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">DOB:</td>
                                <td>{inputs.dob}</td>
                              </tr>
                            </tbody>
                          </table>
                          <br />
                          <div
                            style={{
                              display: "flex",
                              "justify-content": "flex-end",
                            }}
                          >
                            <ActionsBtn />
                          </div>
                        </div>
                      ) : (
                        <form
                          className="form-horizontal"
                          onSubmit={handleSubmit}
                        >
                          <div className="tab-content" id="myTabContent">
                            <div
                              className={`tab-pane fade ${activeTab === "Applications" ? "show active" : ""}`}
                              id="Applications-tab-pane"
                              role="tabpanel"
                              aria-labelledby="Applications-tab"
                            >
                              <div className="row">
                                <div className="col-sm-6">
                                  <div className="form-group">
                                    <label
                                      htmlFor="applicationType"
                                      className="font-weight-bold"
                                    >
                                      Application type
                                    </label>
                                    <select
                                      className="form-control"
                                      name="applicationType"
                                      required
                                      value={inputs.applicationType || ""}
                                      onChange={(e) => handleInputChange(e)}
                                    >
                                      <option value="">
                                        Select application Type
                                      </option>
                                      {applicationTypeOptions &&
                                        applicationTypeOptions.map(
                                          (country) => (
                                            <option
                                              key={country.name}
                                              value={country.name}
                                            >
                                              {country.name}
                                            </option>
                                          ),
                                        )}
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm">
                                  <div className="form-group">
                                    <label
                                      htmlFor="genderId"
                                      className="font-weight-bold"
                                    >
                                      Permit type
                                    </label>
                                    <select
                                      className="form-control"
                                      name="permitType"
                                      required
                                      value={inputs.permitType || ""}
                                      onChange={(e) => handleInputChange(e)}
                                    >
                                      <option value="">
                                        Select Permit type
                                      </option>
                                      {permitTypeOptions &&
                                        permitTypeOptions.map((country) => (
                                          <option
                                            key={country.name}
                                            value={country.name}
                                          >
                                            {country.name}
                                          </option>
                                        ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="col-sm-6">
                                  <div className="form-group">
                                    <label
                                      htmlFor="passportNumber"
                                      className="font-weight-bold"
                                    >
                                      Passport Number
                                    </label>
                                    <input
                                      type="textl"
                                      className="form-control"
                                      name="passportNumber"
                                      required
                                      value={inputs.passportNumber || ""}
                                      onChange={(e) => handleInputChange(e)}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm">
                                  <div className="form-group">
                                    <label
                                      htmlFor="genderId"
                                      className="font-weight-bold"
                                    >
                                      Role
                                    </label>
                                    <select
                                      className="form-control"
                                      name="roleId"
                                      required
                                      value={inputs.roleId || ""}
                                      onChange={(e) => handleInputChange(e)}
                                    >
                                      <option value="">Select Role</option>
                                      {rolesptions &&
                                        rolesptions.map((country) => (
                                          <option
                                            key={country.id}
                                            value={country.id}
                                          >
                                            {country.name}
                                          </option>
                                        ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="col-sm-6">
                                  <div className="form-group">
                                    <label
                                      htmlFor="roleDesc"
                                      className="font-weight-bold"
                                    >
                                      Role description
                                    </label>
                                    <input
                                      type="textl"
                                      className="form-control"
                                      name="roleDesc"
                                      required
                                      value={inputs.roleDesc || ""}
                                      onChange={(e) => handleInputChange(e)}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm">
                                  <div className="form-group">
                                    <label
                                      htmlFor="fullName"
                                      className="font-weight-bold"
                                    >
                                      Full Name
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="fullName"
                                      required
                                      value={inputs.fullName || ""}
                                      onChange={(e) => handleInputChange(e)}
                                    />
                                  </div>
                                </div>
                                <div className="col-sm">
                                  <div className="form-group">
                                    <label
                                      htmlFor="telNo"
                                      className="font-weight-bold"
                                    >
                                      Mobile Number
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="telNo"
                                      required
                                      value={inputs.telNo || ""}
                                      onChange={(e) => handleInputChange(e)}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm">
                                  <div className="form-group">
                                    <label
                                      htmlFor="countryId"
                                      className="font-weight-bold"
                                    >
                                      Nationality
                                    </label>
                                    <select
                                      className="form-control"
                                      name="countryId"
                                      required
                                      value={inputs.countryId || ""}
                                      onChange={(e) => handleInputChange(e)}
                                    >
                                      <option value="">
                                        Select Nationality
                                      </option>
                                      {countryOptions &&
                                        countryOptions.map((country) => (
                                          <option
                                            key={country.countryId}
                                            value={country.countryId}
                                          >
                                            {country.name}
                                          </option>
                                        ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="col-sm">
                                  <div className="form-group">
                                    <label
                                      htmlFor="genderId"
                                      className="font-weight-bold"
                                    >
                                      Gender
                                    </label>
                                    <select
                                      className="form-control"
                                      name="genderId"
                                      required
                                      value={inputs.genderId || ""}
                                      onChange={(e) => handleInputChange(e)}
                                    >
                                      <option value="">Select Gender</option>
                                      {genderOptions &&
                                        genderOptions.map((country) => (
                                          <option
                                            key={country.genderId}
                                            value={country.genderId}
                                          >
                                            {country.name}
                                          </option>
                                        ))}
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm">
                                  <div className="form-group">
                                    <label
                                      htmlFor="email"
                                      className="font-weight-bold"
                                    >
                                      Email
                                    </label>
                                    <input
                                      type="email"
                                      className="form-control"
                                      name="email"
                                      required
                                      value={inputs.email || ""}
                                      onChange={(e) => handleInputChange(e)}
                                    />
                                  </div>
                                </div>
                                <div className="col-sm">
                                  <div className="form-group">
                                    <label
                                      htmlFor="physicalAddress"
                                      className="font-weight-bold"
                                    >
                                      Pysical Address
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="physicalAddress"
                                      required
                                      value={inputs.physicalAddress || ""}
                                      onChange={(e) => handleInputChange(e)}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm">
                                  <div className="form-group">
                                    <label
                                      htmlFor="dob"
                                      className="font-weight-bold"
                                    >
                                      DOB
                                    </label>
                                    <input
                                      type="date"
                                      className="form-control"
                                      name="dob"
                                      required
                                      max={
                                        new Date(
                                          new Date().setFullYear(
                                            new Date().getFullYear() - 18,
                                          ),
                                        )
                                          .toISOString()
                                          .split("T")[0]
                                      }
                                      value={inputs.dob || ""}
                                      onChange={(e) => handleInputChange(e)}
                                    />
                                  </div>
                                </div>
                                <div className="col-sm">
                                  <div className="form-group">
                                    <label
                                      htmlFor="placesOfBirth"
                                      className="font-weight-bold"
                                    >
                                      Place Of Birth
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="placesOfBirth"
                                      required
                                      value={inputs.placesOfBirth || ""}
                                      onChange={(e) => handleInputChange(e)}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm">
                                  <div className="form-group">
                                    <label
                                      htmlFor="dob"
                                      className="font-weight-bold"
                                    >
                                      Number of Kenyan Employees
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      name="kenyanEmployees"
                                      required
                                      value={inputs.kenyanEmployees || ""}
                                      onChange={(e) => handleInputChange(e)}
                                    />
                                  </div>
                                </div>
                                <div className="col-sm">
                                  <div className="form-group">
                                    <label
                                      htmlFor="placesOfBirth"
                                      className="font-weight-bold"
                                    >
                                      Number Of Expatriates
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      name="numberOfExpatriates"
                                      required
                                      value={inputs.numberOfExpatriates || ""}
                                      onChange={(e) => handleInputChange(e)}
                                    />
                                  </div>
                                </div>
                                <div className="col-sm">
                                  <div className="form-group">
                                    <label
                                      htmlFor="placesOfBirth"
                                      className="font-weight-bold"
                                    >
                                      Location
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="location"
                                      required
                                      value={inputs.location || ""}
                                      onChange={(e) => handleInputChange(e)}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <div className="d-flex flex-row">
                              {update ? (
                                <button
                                  className="btn btn-success p-2"
                                  type="submit"
                                >
                                  Update
                                </button>
                              ) : (
                                <button
                                  className="btn btn-success p-2"
                                  type="submit"
                                >
                                  Submit
                                </button>
                              )}
                              &nbsp;
                              <button
                                className="btn btn-warning p-2"
                                type="button"
                                onClick={handleCloseModal}
                              >
                                Close
                              </button>
                            </div>
                            <br />
                          </div>
                        </form>
                      )}
                    </div>
                    <div
                      className={`tab-pane fade ${activeTab === "dependants" ? "show active" : ""}`}
                      id="areas-tab-pane"
                      role="tabpanel"
                      aria-labelledby="dependants-tab"
                    >
                      <form
                        className="form-horizontal"
                        onSubmit={handleSubmitDocuments}
                      >
                        <div className="document-list">
                          {[
                            {
                              label: "Copy of completed application form 25",
                              key: "form_25",
                            },

                            {
                              label:
                                "Letter explaining purpose of entry addressed to PS, Ministry of Tourism",
                              key: "letter_explaining_purpose",
                            },
                            {
                              label: "Copy of valid passport of Applicant",
                              key: "passport_copy",
                            },
                            ...(inputs.applicationType === "Renewal"
                              ? [
                                  {
                                    label:
                                      "Copy of current entry permit (Renewal only)",
                                    key: "current_permit",
                                  },
                                ]
                              : []),
                            {
                              label: "Copy of Tourism license for the company",
                              key: "tourism_license",
                            },
                            ...(inputs.applicationType === "New application"
                              ? [
                                  {
                                    label:
                                      "Certificate of incorporation of the company",
                                    key: "certificate_of_incorporation",
                                  },
                                ]
                              : []),

                            ...(inputs.permitType ===
                            "Entry permit class G (Investor)"
                              ? [
                                  {
                                    label:
                                      "Memorandum & Articles of Association of the company",
                                    key: "memorandum",
                                  },
                                  {
                                    label: "Copy of CR-12",
                                    key: "cr12",
                                  },
                                ]
                              : []),

                            {
                              label: "Company/Applicant PIN",
                              key: "pin",
                            },
                            ...(inputs.applicationType === "Renewal" ||
                            inputs.permitType ===
                              "Entry permit class D (Employed)"
                              ? [
                                  {
                                    label:
                                      "Valid KRA Tax Compliance Certificate",
                                    key: "tax_compliance",
                                  },
                                ]
                              : []),
                            {
                              label:
                                "Valid Tourism Fund Clearance (for levy payers and renewals)",
                              key: "tourism_fund_clearance",
                            },
                            ...(inputs.applicationType === "Renewal"
                              ? [
                                  {
                                    label:
                                      "Audited accounts for the company (Renewals only)",
                                    key: "audited_account",
                                  },
                                ]
                              : []),

                            ...(inputs.permitType ===
                            "Entry permit class G (Investor)"
                              ? [
                                  {
                                    label:
                                      "Proof of capital investment (USD 100,000)",
                                    key: "proof_of_capital",
                                  },
                                ]
                              : []),

                            ...(inputs.applicationType === "Renewal" ||
                            inputs.permitType !==
                              "Entry permit class G (Investor)"
                              ? [
                                  {
                                    label: `Employee profile ${
                                      inputs.permitType ===
                                      "Entry permit class G (Investor)"
                                        ? "(Details of all employees in the company - citizens and non-citizens; ID & passport numbers)"
                                        : ""
                                    }`,
                                    key: "employee_profile",
                                  },
                                ]
                              : []),
                            ...(inputs.permitType ===
                            "Entry permit class D (Employed)"
                              ? [
                                  {
                                    label:
                                      "Copy of completed application form 27",
                                    key: "form_27",
                                  },
                                  {
                                    label:
                                      "Contract offer of employment authored by the employer",
                                    key: "employee_contract",
                                  },
                                  {
                                    label:
                                      "Comprehensive CV and testimonials translated into English (All in one pdf document)",
                                    key: "employee_cv",
                                  },
                                  {
                                    label:
                                      "Proof of an understudy with certificates, CV, ID copy and contract (All in one pdf document)",
                                    key: "employee_certificates",
                                  },
                                  {
                                    label:
                                      "Notarized copies of academic qualifications and/or proof of specialized skills",
                                    key: "employee_notorzed_docs",
                                  },
                                ]
                              : []),
                            ...(inputs.permitType ===
                            "Entry permit special pass"
                              ? [
                                  {
                                    label:
                                      "Valid Tourism Fund Clearance for the company",
                                    key: "tourism_fund_cert",
                                  },
                                ]
                              : []),
                          ].map((doc, index) => (
                            <div className="document-row" key={doc.key}>
                              <div className="document-number">
                                {index + 1}.
                              </div>

                              <div className="document-label">{doc.label}</div>

                              <div className="document-upload">
                                <input
                                  type="file"
                                  name="file"
                                  onChange={(e) => onChangeHandler(e, doc.key)}
                                  accept=".pdf"
                                  className="form-control"
                                />
                              </div>

                              <div className="document-view">
                                {inputsDocuments[doc.key] ? (
                                  <a
                                    href={
                                      process.env.REACT_APP_BASE_URL +
                                      "api/upload/files/" +
                                      inputsDocuments[doc.key]
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-sm btn-primary"
                                  >
                                    View
                                  </a>
                                ) : (
                                  <span className="text-muted">No file</span>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="row mt-4">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label className="font-weight-bold">
                                Enter comment
                              </label>

                              <textarea
                                className="form-control"
                                name="comments"
                                required
                                rows={4}
                                value={inputsDocuments.comments}
                                onChange={handleDocumentsInputChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="d-flex justify-content-end mt-4">
                          <div className="d-flex flex-row">
                            <button
                              className="btn btn-success p-2"
                              type="submit"
                            >
                              {update ? "Update" : "Submit"}
                            </button>
                            &nbsp;
                            <button
                              className="btn btn-warning p-2"
                              type="button"
                              onClick={handleCloseModal}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <br />
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    {/* <ActionsBtn /> */}
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default NewApplication;
